(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["aurabreath-scroll-motion"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('aurabreath-scroll-motion')) {
  customElements.define('aurabreath-scroll-motion', class extends HTMLElement {
    connectedCallback() {
      this.events = new AbortController();
      this.animations = new Set();
      this.motion = matchMedia('(prefers-reduced-motion: reduce)');
      this.mobile = matchMedia('(max-width: 749px)');
      const options = { signal: this.events.signal };
      this.motion.addEventListener('change', () => {
        if (this.motion.matches) this.finishAll();
      }, options);
      document.addEventListener('shopify:section:load', () => this.scan(), options);
      document.addEventListener('visibilitychange', () => {
        if (document.hidden) this.finishAll();
      }, options);
      document.addEventListener('focusin', event => {
        const target = event.target.closest?.('[data-ab-motion]');
        if (target) this.finishTarget(target);
      }, options);
      let width = innerWidth;
      window.addEventListener('resize', () => {
        if (innerWidth !== width) { width = innerWidth; this.finishAll(); }
      }, options);
      if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', () => this.start(), { ...options, once: true });
      } else this.start();
    }
    start() {
      if (this.observer || !('IntersectionObserver' in window) || !Element.prototype.animate || window.Shopify?.designMode) return;
      this.observer = new IntersectionObserver(entries => {
        entries.forEach(entry => {
          if (!entry.isIntersecting) return;
          this.observer.unobserve(entry.target);
          this.reveal(entry.target);
        });
      }, { threshold: 0.12, rootMargin: '0px 0px -32px 0px' });
      this.scan();
    }
    scan() {
      if (!this.observer) return;
      const main = document.getElementById('MainContent');
      if (!main) return;
      main.querySelectorAll('h2').forEach(heading => {
        if (heading.closest('product-info, product-recommendations, [hidden]') || !heading.getClientRects().length) return;
        this.register(heading, 'title');
      });
      main.querySelectorAll('.ab-guide__visual, [class^="ab-tech__visual-"], .aurabreath-four-benefits__viewport').forEach(element => this.register(element, 'visual'));
      main.querySelectorAll('.ab-guide__heading > p, .aurabreath-faq__intro, [class^="ab-tech__subtitle-"]').forEach(element => this.register(element, 'copy'));
    }
    register(element, type) {
      if (element.dataset.abMotion) return;
      element.closest(".shopify-section")?.classList.add("ab-motion-section");
      element.dataset.abMotion = type;
      element.dataset.abMotionState = 'waiting';
      if (type === 'title') this.splitWords(element);
      const rect = element.getBoundingClientRect();
      if (rect.top < innerHeight && rect.bottom > 0) {
        element.dataset.abMotionState = 'shown';
        return;
      }
      this.observer.observe(element);
    }
    splitWords(heading) {
      const walker = document.createTreeWalker(heading, NodeFilter.SHOW_TEXT);
      const nodes = [];
      while (walker.nextNode()) {
        if (walker.currentNode.textContent.trim()) nodes.push(walker.currentNode);
      }
      nodes.forEach(node => {
        const fragment = document.createDocumentFragment();
        node.textContent.replace(/[ \t]+(?=[?!:;])/g, '\u00a0').split(/([ \t\r\n]+)/).forEach(token => {
          if (!token) return;
          if (!token.trim()) fragment.append(document.createTextNode(token));
          else {
            const word = document.createElement('span');
            word.className = 'ab-motion-word';
            word.textContent = token;
            fragment.append(word);
          }
        });
        node.replaceWith(fragment);
      });
    }
    reveal(target) {
      target.dataset.abMotionState = 'shown';
      if (this.motion.matches || document.hidden) return;
      const type = target.dataset.abMotion;
      const small = this.mobile.matches;
      if (type === 'title') {
        target.querySelectorAll('.ab-motion-word').forEach((word, index) => {
          this.play(word, [{ opacity: 0, transform: `translateY(${small ? 40 : 75}%)` }, { opacity: 1, transform: 'translateY(0)' }], small ? 560 : 760, Math.min(index, 10) * (small ? 22 : 30), target);
        });
      } else {
        const frames = type === 'visual'
          ? [{ opacity: 0.35, transform: `scale(${small ? 1.025 : 1.055})` }, { opacity: 1, transform: 'scale(1)' }]
          : [{ opacity: 0, transform: `translateY(${small ? 10 : 18}px)` }, { opacity: 1, transform: 'translateY(0)' }];
        this.play(target, frames, small ? 650 : 950, type === 'copy' ? 100 : 0, target);
      }
    }
    play(element, frames, duration, delay, owner) {
      const animation = element.animate(frames, { duration, delay, easing: 'cubic-bezier(.22,1,.36,1)', fill: 'backwards' });
      const entry = { animation, owner };
      this.animations.add(entry);
      const release = () => this.animations.delete(entry);
      animation.addEventListener('finish', release, { once: true });
      animation.addEventListener('cancel', release, { once: true });
    }
    finishTarget(target) {
      for (const entry of this.animations) {
        if (entry.owner === target) entry.animation.cancel();
      }
    }
    finishAll() {
      this.animations.forEach(entry => entry.animation.cancel());
      this.animations.clear();
    }
    disconnectedCallback() {
      this.events?.abort();
      this.observer?.disconnect();
      this.finishAll();
    }
  });
}
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["aurastep-home-chat"] && !Shopify.designMode) return;
  try {
    class AuraStepHomeChat extends HTMLElement {
  connectedCallback() {
    this.trigger = this.querySelector('[data-chat-trigger]');
    this.panel = this.querySelector('[data-chat-panel]');
    this.closeButton = this.querySelector('[data-chat-close]');

    this.trigger.addEventListener('click', () => this.setOpen(!this.classList.contains('is-open')));
    this.closeButton.addEventListener('click', () => this.setOpen(false));

    document.addEventListener('keydown', (event) => {
      if (event.key === 'Escape') this.setOpen(false);
    });

    window.setTimeout(() => this.classList.add('is-notification-hidden'), 7000);
  }

  setOpen(open) {
    this.classList.toggle('is-open', open);
    this.classList.add('is-notification-hidden');
    this.trigger.setAttribute('aria-expanded', String(open));
    this.panel.setAttribute('aria-hidden', String(!open));
    if (open) this.closeButton.focus();
    else this.trigger.focus();
  }
}

if (!customElements.get('aurastep-home-chat')) {
  customElements.define('aurastep-home-chat', AuraStepHomeChat);
}
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["aurastep-home-motion"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('aurastep-home-motion')) {
  customElements.define('aurastep-home-motion', class extends HTMLElement {
    connectedCallback() {
      if (this.events) return;
      this.events = new AbortController();
      this.animations = new Set();
      this.motion = matchMedia('(prefers-reduced-motion: reduce)');
      this.mobile = matchMedia('(max-width: 749px)');
      const options = { signal: this.events.signal };
      this.motion.addEventListener('change', () => this.finishAll(), options);
      document.addEventListener('visibilitychange', () => {
        if (document.hidden) this.finishAll();
      }, options);
      document.addEventListener('focusin', event => {
        const target = event.target.closest?.('[data-as-home-motion]');
        if (!target) return;
        this.observer?.unobserve(target);
        target.dataset.asHomeMotionState = 'shown';
        for (const entry of this.animations) {
          if (entry.owner === target) entry.animation.cancel();
        }
      }, options);
      document.addEventListener('shopify:section:load', () => this.scan(), options);
      let width = innerWidth;
      window.addEventListener('resize', () => {
        if (innerWidth !== width) { width = innerWidth; this.finishAll(); }
      }, options);
      if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', () => this.start(), { ...options, once: true });
      } else this.start();
    }
    start() {
      if (this.observer || !('IntersectionObserver' in window) || !Element.prototype.animate || window.Shopify?.designMode) return;
      this.observer = new IntersectionObserver(entries => {
        entries.forEach(entry => {
          if (!entry.isIntersecting) return;
          this.observer.unobserve(entry.target);
          this.reveal(entry.target);
        });
      }, { threshold: 0.08, rootMargin: '0px 0px -24px 0px' });
      this.scan();
    }
    scan() {
      if (!this.observer) return;
      const main = document.getElementById('MainContent');
      if (!main) return;
      main.querySelectorAll('h2').forEach(heading => {
        if (heading.closest('slideshow-component, [class*="ai-premium-banner"], product-info, product-recommendations, [hidden]')) return;
        const type = heading.querySelector('[class*="headline-mobile"]') ? 'copy' : 'title';
        this.register(heading, type);
      });
      main.querySelectorAll('.as-product-card__image img, .as-sleep__scene, [class*="ai-wellness-science-card-image-wrapper-"] img, [class*="ai-category-image-wrapper-"] img, .image-with-text__media img, [class*="ai-faq-image-wrapper-"] img, [class*="ai-blog-card__image-wrapper-"] img').forEach(image => {
        this.register(image, 'visual');
      });
      main.querySelectorAll('.as-bestsellers__header > p, .as-sleep__description, [class*="ai-video-showcase-subtitle-"], [class*="ai-trust-carousel-subtitle-"], [class*="ai-wellness-science-subtitle-"], .image-with-text__text, [class*="ai-review-carousel-subtitle-"], [class*="ai-faq-description-"], [class*="ai-blog-collection__subtitle-"]').forEach(element => this.register(element, 'copy'));
    }
    register(element, type) {
      if (element.dataset.asHomeMotion || !element.getClientRects().length) return;
      const rect = element.getBoundingClientRect();
      element.dataset.asHomeMotion = type;
      element.closest('.shopify-section')?.classList.add('as-home-motion-scope');
      if (type === 'visual') element.parentElement.classList.add('as-home-motion-media');
      if (rect.top < innerHeight) {
        element.dataset.asHomeMotionState = 'shown';
        return;
      }
      if (type === 'title') this.splitWords(element);
      element.dataset.asHomeMotionState = 'waiting';
      this.observer.observe(element);
    }
    splitWords(heading) {
      const walker = document.createTreeWalker(heading, NodeFilter.SHOW_TEXT);
      const nodes = [];
      while (walker.nextNode()) {
        if (walker.currentNode.textContent.trim()) nodes.push(walker.currentNode);
      }
      nodes.forEach(node => {
        const fragment = document.createDocumentFragment();
        node.textContent.replace(/[ \t]+(?=[?!:;])/g, '\u00a0').split(/([ \t\r\n]+)/).forEach(token => {
          if (!token) return;
          if (!token.trim()) fragment.append(document.createTextNode(token));
          else {
            const word = document.createElement('span');
            word.className = 'as-home-motion-word';
            word.textContent = token;
            fragment.append(word);
          }
        });
        node.replaceWith(fragment);
      });
    }
    reveal(target) {
      target.dataset.asHomeMotionState = 'shown';
      if (this.motion.matches || document.hidden || !target.isConnected) return;
      const small = this.mobile.matches;
      const type = target.dataset.asHomeMotion;
      if (type === 'title') {
        target.querySelectorAll('.as-home-motion-word').forEach((word, index) => {
          this.play(word, [
            { opacity: 0.12, transform: `translateY(${small ? 24 : 40}%)` },
            { opacity: 1, transform: 'translateY(0)' }
          ], small ? 620 : 820, Math.min(index, 10) * (small ? 18 : 26), target);
        });
      } else {
        const frames = type === 'visual'
          ? [{ opacity: 0.55, transform: `scale(${small ? 1.015 : 1.035})` }, { opacity: 1, transform: 'scale(1)' }]
          : [{ opacity: 0.15, transform: `translateY(${small ? 8 : 14}px)` }, { opacity: 1, transform: 'translateY(0)' }];
        this.play(target, frames, small ? 720 : 1000, type === 'copy' ? 70 : 0, target);
      }
    }
    play(element, frames, duration, delay, owner) {
      const animation = element.animate(frames, { duration, delay, easing: 'cubic-bezier(.22,1,.36,1)', fill: 'backwards' });
      const entry = { animation, owner };
      this.animations.add(entry);
      const release = () => this.animations.delete(entry);
      animation.addEventListener('finish', release, { once: true });
      animation.addEventListener('cancel', release, { once: true });
    }
    finishAll() {
      this.animations?.forEach(entry => entry.animation.cancel());
      this.animations?.clear();
    }
    disconnectedCallback() {
      this.events?.abort();
      this.observer?.disconnect();
      this.finishAll();
      this.events = null;
      this.observer = null;
    }
  });
}
  } catch(e) { console.error(e); }
})();

})();
